import {
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  TwitterLogo,
} from "@phosphor-icons/react/dist/ssr";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";

export default function AuthorContent({ data }) {
  const [expandedAuthors, setExpandedAuthors] = useState({});

  const toggleAuthorDescription = (authorId) => {
    setExpandedAuthors((prev) => ({
      ...prev,
      [authorId]: !prev[authorId],
    }));
  };

  return (
    <>
      {data && data.length > 0 && (
        <div className='mx-auto not-prose'>
          <h3 className='mb-4 text-lg font-semibold lg:text-3xl'>
            {data.length === 1 ? "Author" : "Authors"}
          </h3>
          <div className='space-y-1 lg:space-y-2'>
            {data.map((author, index) => (
              <div
                key={author.uuid}
                className='flex items-start p-4 space-x-4 border rounded-lg bg-white/5 border-white/5'
              >
                <div className='relative flex-shrink-0 size-14 lg:size-16'>
                  {author.photo_profile_url ? (
                    <Image
                      src={author.photo_profile_url}
                      alt={
                        author.photo_profile_alt ||
                        `${author.name} profile photo`
                      }
                      layout='fill'
                      className='object-cover rounded-full'
                    />
                  ) : (
                    <div className='flex items-center justify-center rounded-full size-12 lg:size-16 bg-gradient-to-br from-yellow-1 to-red-1'>
                      <span className='text-2xl font-bold text-white'>
                        {author.name.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  )}
                </div>
                <div className='flex-1'>
                  <div className='flex items-start space-x-3'>
                    <Link
                      href={`/author/${author.slug}`}
                      className='flex-1 no-underline'
                    >
                      <h4
                        className={`text-base lg:text-lg leading-tight font-semibold text-white hover:text-yellow-1 transition-colors ${
                          author.description ? "mt-0" : ""
                        }`}
                      >
                        {author.name}
                      </h4>
                    </Link>

                    <div className='flex items-center space-x-3'>
                      {author.linkedin_url && (
                        <a
                          href={author.linkedin_url}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='transition-colors text-white/60 hover:text-white'
                        >
                          <LinkedinLogo size={20} weight='bold' />
                        </a>
                      )}
                      {author.twitter_url && (
                        <a
                          href={author.twitter_url}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='transition-colors text-white/60 hover:text-white'
                        >
                          <TwitterLogo size={20} weight='bold' />
                        </a>
                      )}
                      {author.facebook_url && (
                        <a
                          href={author.facebook_url}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='transition-colors text-white/60 hover:text-white'
                        >
                          <FacebookLogo size={20} weight='bold' />
                        </a>
                      )}
                      {author.instagram_url && (
                        <a
                          href={author.instagram_url}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='transition-colors text-white/60 hover:text-white'
                        >
                          <InstagramLogo size={20} weight='bold' />
                        </a>
                      )}
                    </div>
                  </div>
                  {(author.job_title || author.company_name) && (
                    <p className='mt-0.5 text-xs text-white/50'>
                      {author.job_title && author.company_name
                        ? `${author.job_title} of ${author.company_name}`
                        : author.job_title || author.company_name}
                    </p>
                  )}
                  {author.description && (
                    <div className='mt-2 text-xs leading-relaxed lg:text-sm text-white/50'>
                      <p
                        className={
                          expandedAuthors[author.id] ? "" : "line-clamp-2"
                        }
                      >
                        {author.description}
                      </p>
                      {author.description.length > 200 && (
                        <button
                          onClick={() => toggleAuthorDescription(author.id)}
                          className='mt-3 text-xs font-medium transition-colors text-yellow-1 hover:text-yellow-2'
                        >
                          {expandedAuthors[author.id]
                            ? "Show less"
                            : "Show more"}
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
